<ms-participant-image [participantImage]="participant.image" [sportId]="sportId" [showLogoColor]="showLogoColor"></ms-participant-image>

<div class="participant-group">
    <ms-scoreboard-participant
        class="participant-info"
        [showIndicator]="false"
        [event]="event"
        [participant]="participant"
        [isNewEDPScoreboard]="isNewEDPScoreboard">
    </ms-scoreboard-participant>
    <ng-container *ngIf="!isNewEDPScoreboard; else cards">
        <div class="red-card" *ngIf="redCardsCount >= 1">
            <span class="red-card-count" *ngIf="redCardsCount > 1">{{ redCards.length }}</span>
        </div>
    </ng-container>
</div>

<ng-template #cards>
    <ng-container *ngIf="redCardsCount >= 1">
        <div class="red-card" *ngFor="let redCard of redCards"></div>
    </ng-container>
</ng-template>
